import { z } from "zod";

export const preRegisterTermsFormSchema = z
  .object({
    agreeAll: z.boolean(),
    agreePcCafeTerms: z.boolean(),
    agreePrivacyPolicy: z.boolean(),
  })
  .refine((data) => data.agreePcCafeTerms, {
    message: "",
    path: ["agreePcCafeTerms"],
  })
  .refine((data) => data.agreePrivacyPolicy, {
    message: "",
    path: ["agreePrivacyPolicy"],
  });

export type PreRegisterTermsFormType = z.infer<typeof preRegisterTermsFormSchema>;
